module.exports = __webpack_public_path__ + "static/media/last.296f44a3.svg";